import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PreviewTableHeaderComponent from './previewTableHeader.component';
import PreviewTableRowComponent from './previewTableRow.component';
import TablePaginationComponent from '../../common/tablePagination.component';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class PreviewTableComponent extends React.Component {
  constructor(props) {
    super(props);

    this.populateMetadata = this.populateMetadata.bind(this);
    this.handleRequestSort = this.handleRequestSort.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.sortData = this.sortData.bind(this);
    this.renderTableRows = this.renderTableRows.bind(this);

    const metadata = this.populateMetadata();
    const order = 'asc';
    const orderBy = metadata[Object.keys(metadata)[0]].key;
    const headerRow = this.createHeaderRow(metadata);

    this.state = {
      metadata,
      headerRow,
      order,
      orderBy,
      data: this.sortData(order, orderBy),
      page: 0,
      rowsPerPage: 50,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({
        data: this.sortData(prevProps.order, prevProps.orderBy),
      });
    }
  }
  createHeaderRow(metadata) {
    return Object.values(metadata).sort((a, b) => a.index - b.index)
    .map(({ key, name }) => ({ key, name }));
  }
  populateMetadata() {
    return _.pickBy(this.props.metadata, column => column.type.toLowerCase() !== 'skip');
  }

  handleRequestSort(event, key) {
    let order = 'desc';
    const orderBy = key;

    if (this.state.orderBy === key && this.state.order === 'desc') {
      order = 'asc';
    }

    const data = this.sortData(order, orderBy);
    this.setState({ data, order, orderBy });
  }

  handleChangePage(event, page) {
    this.setState({ page });
  }

  handleChangeRowsPerPage(event) {
    this.setState({ rowsPerPage: event.target.value });
  }

  sortData(order, orderBy) {
    return order === 'desc'
      ? this.props.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
      : this.props.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));
  }

  renderTableRows() {
    const {
      page,
      rowsPerPage,
      headerRow,
      data,
    } = this.state;

    const begin = page * rowsPerPage;
    const end = begin + rowsPerPage;
    return data.slice(begin, end).map((row, index) => (
      <PreviewTableRowComponent key={index} headers={headerRow} row={row} />
    ));
  }

  render() {
    const { classes } = this.props;
    const {
      headerRow,
      order,
      orderBy,
      rowsPerPage,
      page,
      data,
    } = this.state;

    return (
      <React.Fragment>
        <div style={{ padding: '25px 0 0 25px' }}>
          <Typography variant="h4" gutterBottom>Preview</Typography>
        </div>
        <div className={classes.tableWrapper}>
          <Table className={classes.table} aria-labelledby="tableTitle">
            <PreviewTableHeaderComponent
              order={order}
              orderBy={orderBy}
              row={headerRow}
              onRequestSort={this.handleRequestSort}
            />
            <TableBody>
              {this.renderTableRows()}
            </TableBody>
          </Table>
        </div>
        <TablePaginationComponent
          page={page}
          rowsPerPage={rowsPerPage}
          totalRows={data.length}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
        />
      </React.Fragment>
    );
  }
}

PreviewTableComponent.propTypes = {
  metadata: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(PreviewTableComponent);
